export const theme = {
  primary: "#7D40E7",
  secondary: "#ce0f4e",
  background: "#FFF",
};
